import { assert } from './assert-sidecar'

export function rgb(r: number, g: number, b: number) {
  return (r << 16) + (g << 8) + b
}
export function hex(h: string): number {
  if (h.startsWith('#')) {
    h = h.substring(1)
  }
  if (h.length === 6) {
    let r = parseInt(h.substring(0, 2), 16)
    let g = parseInt(h.substring(2, 4), 16)
    let b = parseInt(h.substring(4, 6), 16)
    return rgb(r, g, b)
  }
  assert.failed('invalid hex string', h)
  return 0
}
